export const isDev = false; //window.location.hostname === 'localhost';

export const localDev = window.location.hostname === 'localhost';

export const isCORS = true;

export const apiUrl = localDev ? 'http://127.0.0.1:17701/api' : 'https://v1.l0ve.lol/api';

export const getToken = () => localStorage.getItem('sessionToken');
